module.exports = __webpack_public_path__ + "media/images/tick_new-f4bace448f2b7a9e9f2d32a8d8646499.svg";